<template>
  <div class="genres-page-content pc-container" data-v-38312c58="" style="margin-top: 50px">
    <div class="genres-tags-container" data-v-38312c58="" data-v-88b01a07="">
      <!-- <div class="genres_breadcrumb" data-v-88b01a07="" data-v-1db6e0a4="">
        <a class="home_link" data-v-1db6e0a4="">Home</a>
        <span class="split" data-v-1db6e0a4="">/</span>
        <a aria-current="page" class="router-link-active router-link-exact-active all_link" data-v-1db6e0a4="">All Plots</a>
      </div> -->
      <!-- <div class="genres-tags" data-v-88b01a07="">
        <div class="tags-container" data-v-88b01a07="">
          <div class="tags-wrapper collapsed" data-v-88b01a07="">
            <div class="tags" :class="{ active: tag_id == 0 }" data-v-88b01a07="">
              <h1 href="/genres/all-plots" data-v-88b01a07="">
                <a data-v-88b01a07="" @click="onTags(0)">All Plots</a>
              </h1>
            </div>
            <div class="tags" :class="{ active: tag_id == item.id }" data-v-88b01a07="" v-for="(item, i) in videoTags" :key="i">
              <h2 data-v-88b01a07="">
                <a data-v-88b01a07="" @click="onTags(item.id)">{{ item.name }}</a>
              </h2>
            </div>
            <div style="" class="expand-icon-tag" data-v-88b01a07="">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAPFBMVEWMen4AAAD///+hk5aNen749/eOfICNen/GvsCMen+Ne3+PgICNe3+Me3+Me3+Me36LfIDv7OyMen++tbd5WlzXAAAAFHRSTlP/AP//3/8gYP/PkBDvv69wQP+f/9+uXm4AAAEGSURBVHicndRbEoMgDAXQq1KQIr66/722BLQhKtLmS+UMyRgImsrAn1BPqxqAwY5GF6DxYOHNBZwVRChzAt1TshBPJ6G2Z+6zqc6hPqSVMkJ36QDrGDytb6/zC03JAfMOC4mpzA3ebAiYBP0d9BHqOwdoglvmfnnly6+lT08TwTG+dG3b9tz1nw9dfFwJbs175DK4R4KK4JBWukxyh4HgvgeXmQNyyKRwyFIzKV1MzRsYpXSwBFdIKR1GghOOMneh2ccWBilcaqE8FN0inf/1mFUf3Ga+3/DHy9W4i+tPifl1rR4A19KKkVI/pMLvPI69+WTsEa0bpFSqGW0YzWqdSqO5FNXwDf94B8zA4EL2AAAAAElFTkSuQmCC" alt="unfold" data-v-88b01a07="" />
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="genres-page-content-play" data-v-38312c58="">
      <div class="genres-play" data-v-38312c58="" data-v-d78d25a7="">
        <div class="genres-play-container" data-v-d78d25a7="">
          <!--[-->
          <div class="genres-play-item" data-v-d78d25a7="" v-for="(item, i) in videoList" :key="i">
            <div class="left-content" data-v-d78d25a7="">
              <div class="img-cover" data-v-d78d25a7="">
                <img :src="item.img" :alt="item.title" data-v-d78d25a7="" />
              </div>
            </div>
            <div class="right-content" data-v-d78d25a7="">
              <div class="top" data-v-d78d25a7="">
                <h3 class="title" data-v-d78d25a7="">{{ item.title }}</h3>
                <div class="icon-wrapper" data-v-d78d25a7="">
                  <div class="icon-item" data-v-d78d25a7="">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAPFBMVEUAAAD/aCL/aCP/aCL/aCj/cCD/aCP/ZyL/aCD/aCP/ZiL/aCL/aCT/aSL/ZSX/aCL/aCL/aSL/aiX/aSPSL4PoAAAAFHRSTlMA/7/fIBBg7yCvcI9AzzB/n3AwUPdwkfIAAACmSURBVHic7dPZEsIgDAXQJilLKRSq//+vKtQZkLC8Onpfe2a4TWBZvjN3Oec8wD7jLDxjx07TC5IYwgAx28gZuHIODlZvqNZxwRTXlKtBKIKGsdYTMHH7rWCH4lQK5RTbrpyU78F8n4IteB1dLKlT8uPPz5arNhR4F6pB8jWJGfkxUTDF1Q45x039d6BCKbcujF9RxssikuWhRjTZldISsfsS/8nyAE/kBGwm7s0+AAAAAElFTkSuQmCC" alt="collect" width="20" height="20" data-v-d78d25a7="" />
                    <span class="icon-text" data-v-d78d25a7="">{{ $common.formatK(item.collect) }}</span>
                  </div>
                  <!-- <div class="icon-item" data-v-d78d25a7="">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAMAAABU4iNhAAAANlBMVEUAAAD/aCL/aCT/aCL/cCD/aCj/aCP/aCL/ZyL/aSL/aCP/aCP/aCL/ZSX/aSP/ZiP/aCD/ZyKxMrCGAAAAEnRSTlMA/0DfECBggO9wn7+QMK9QIM/wJXoJAAAAlElEQVR4nO3UwQ6DIBREUUZoRcFq//9nqyYmFefBLLpp4qxP9EKMzv3ZpvzUYPCAl2yHbe+HKoGxaQ8J36uymfslgVct4SSruYWsJJRytbMqrQQmgZ5YLlmuIYFBlunnz4wXaJ09aGdP4n36jrmrJIFcZhLIZJpMd/7mjcBSRnYzTI4Nd8hUf/G+ENV/iFtyK/CesA/6OwNpX9xLpAAAAABJRU5ErkJggg==" alt="watch" width="20" height="20" data-v-d78d25a7="" />
                    <span class="icon-text" data-v-d78d25a7="">8.4K</span>
                  </div> -->
                </div>
                <span class="desc" data-v-d78d25a7="">{{ item.content }}</span>
              </div>
              <div class="bottom" data-v-d78d25a7="">
                <div class="play-btn" data-v-d78d25a7="" @click="onPlay(item.code)"><span class="play-icon" data-v-d78d25a7=""></span>{{ $t('_a._bf') }}</div>
              </div>
            </div>
          </div>
          <!--]-->
        </div>
      </div>
      <!---->
    </div>
    <div data-v-89104e56="" class="custom-pagination-wrapper">
      <div data-v-89104e56="" class="n-pagination nnsee">
        <!---->
        <div class="n-pagination-item n-pagination-item--button" :class="{ 'n-pagination-item--disabled': page == 1 }" @click="onPage(page - 1)">
          <i class="n-base-icon">
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.2674 15.793C11.9675 16.0787 11.4927 16.0672 11.2071 15.7673L6.20572 10.5168C5.9298 10.2271 5.9298 9.7719 6.20572 9.48223L11.2071 4.23177C11.4927 3.93184 11.9675 3.92031 12.2674 4.206C12.5673 4.49169 12.5789 4.96642 12.2932 5.26634L7.78458 9.99952L12.2932 14.7327C12.5789 15.0326 12.5673 15.5074 12.2674 15.793Z" fill="currentColor"></path>
            </svg>
          </i>
        </div>
        <!---->
        <div class="n-pagination-item n-pagination-item--clickable" v-if="pages.showStartEllipsis" @click="onPage(1)">1</div>
        <!---->
        <div class="n-pagination-item" v-if="pages.showStartEllipsis">
          <i class="n-base-icon">
            <svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g fill="currentColor" fill-rule="nonzero">
                  <path d="M4,7 C4.55228,7 5,7.44772 5,8 C5,8.55229 4.55228,9 4,9 C3.44772,9 3,8.55229 3,8 C3,7.44772 3.44772,7 4,7 Z M8,7 C8.55229,7 9,7.44772 9,8 C9,8.55229 8.55229,9 8,9 C7.44772,9 7,8.55229 7,8 C7,7.44772 7.44772,7 8,7 Z M12,7 C12.5523,7 13,7.44772 13,8 C13,8.55229 12.5523,9 12,9 C11.4477,9 11,8.55229 11,8 C11,7.44772 11.4477,7 12,7 Z"></path>
                </g>
              </g>
            </svg>
          </i>
        </div>
        <!---->
        <div class="n-pagination-item n-pagination-item--clickable" :class="{ 'n-pagination-item--active': i == page }" v-for="i in pages.pages" :key="i" @click="onPage(i)">{{ i }}</div>
        <!---->
        <div class="n-pagination-item" v-if="pages.showEndEllipsis">
          <i class="n-base-icon">
            <svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g fill="currentColor" fill-rule="nonzero">
                  <path d="M4,7 C4.55228,7 5,7.44772 5,8 C5,8.55229 4.55228,9 4,9 C3.44772,9 3,8.55229 3,8 C3,7.44772 3.44772,7 4,7 Z M8,7 C8.55229,7 9,7.44772 9,8 C9,8.55229 8.55229,9 8,9 C7.44772,9 7,8.55229 7,8 C7,7.44772 7.44772,7 8,7 Z M12,7 C12.5523,7 13,7.44772 13,8 C13,8.55229 12.5523,9 12,9 C11.4477,9 11,8.55229 11,8 C11,7.44772 11.4477,7 12,7 Z"></path>
                </g>
              </g>
            </svg>
          </i>
        </div>
        <!---->
        <div class="n-pagination-item n-pagination-item--clickable" v-if="pages.showEndEllipsis" @click="onPage(pages.total)">{{ pages.total }}</div>
        <div class="n-pagination-item n-pagination-item--button" :class="{ 'n-pagination-item--disabled': page == pages.total }" @click="onPage(page + 1)">
          <i class="n-base-icon">
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.73271 4.20694C8.03263 3.92125 8.50737 3.93279 8.79306 4.23271L13.7944 9.48318C14.0703 9.77285 14.0703 10.2281 13.7944 10.5178L8.79306 15.7682C8.50737 16.0681 8.03263 16.0797 7.73271 15.794C7.43279 15.5083 7.42125 15.0336 7.70694 14.7336L12.2155 10.0005L7.70694 5.26729C7.42125 4.96737 7.43279 4.49264 7.73271 4.20694Z" fill="currentColor"></path>
            </svg>
          </i>
        </div>
        <!----><!----><!---->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenresVue',
  props: {
    cateId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      videoTags: [],
      tag_id: 0,
      videoList: [],
      page: 1,
      size: 10,
      total: 0
    }
  },
  created() {
    // this.getVideoTagsList()
    this.$nextTick(function () {
      this.getVideoPageList()
    })
  },
  computed: {
    pages() {
      const total = Math.ceil(this.total / this.size) // 总页数
      const current = this.page // 当前页
      const only = 5 // 最多显示5个页码

      let pages = []
      let showStartEllipsis = false // 是否显示前面的省略号
      let showEndEllipsis = false // 是否显示后面的省略号
      let showLast = false // 是否显示最后一页

      if (total <= only) {
        // 总页数小于等于5，显示所有页码
        for (let i = 1; i <= total; i++) {
          pages.push(i)
        }
      } else {
        showLast = true

        if (current <= 3) {
          // 当前页在前3页，显示1-5页
          for (let i = 1; i <= only; i++) {
            pages.push(i)
          }
          showEndEllipsis = true
        } else if (current >= total - 2) {
          // 当前页在最后3页，显示最后5页
          for (let i = total - only + 1; i <= total; i++) {
            pages.push(i)
          }
          showStartEllipsis = true
        } else {
          // 当前页在中间，显示当前页前后各2页
          for (let i = current - 2; i <= current + 2; i++) {
            pages.push(i)
          }
          showStartEllipsis = true
          showEndEllipsis = true
        }
      }

      return {
        pages: pages,
        showStartEllipsis: showStartEllipsis,
        showEndEllipsis: showEndEllipsis,
        showLast: showLast,
        total: total
      }
    }
  },
  methods: {
    getVideoTagsList() {
      let that = this
      this.$api.video.getVideoTagsList({}).then((res) => {
        that.videoTags = res.data
      })
    },
    onTags(id) {
      this.tag_id = id
      this.getVideoPageList()
    },
    getVideoPageList() {
      let that = this
      let hide = this.$message.loading({ content: 'Loading...', key: 'msg' })
      //热门视频
      this.$api.video
        .getVideoPageList({
          cate_id: this.cateId,
          page: this.page,
          size: this.size,
          tag_id: this.tag_id
        })
        .then((res) => {
          hide()
          that.videoList = res.data.data
          that.page = res.data.current
          that.total = res.data.total
        })
    },
    onPlay(code) {
      this.$router.push({ name: 'video', query: { code: code } })
    },
    onPage(page) {
      if (page < 1 || page > this.pages.total) {
        return
      }
      this.page = page
      this.getVideoPageList()
    }
  }
}
</script>

<style scoped>
@import url('@/static/css_genres/1.css');
@import url('@/static/css_genres/2.css');
@import url('@/static/css_genres/3.css');
@import url('@/static/css_genres/4.css');
@import url('@/static/css_genres/5.css');
</style>
